module.exports = __webpack_public_path__ + "static/img/children3.388db013.jpg";